// Edit these placeholder values to match your business.
export const SITE = {
  brand: "INSIGHT",
  brandFull: "Insight Cleaning Co.",
  tagline: "Commercial cleaning, engineered.",
  phone: "0406 979 106",
  phone2: "0450 801 717",
  email: "admin@insightcleaningco.com",
  serviceArea: "Canberra · Queanbeyan · Woden Valley · Gungahlin",
  serviceAreas: [
    "Canberra",
    "Queanbeyan",
    "Queanbeyan East",
    "Woden Valley",
    "Gungahlin",
    "2600",
  ],
  address: "21 Burra Place, Braddon, ACT 2612",
  abn: "20 694 402 358",
  established: "2021",
};

export const SERVICES = [
  {
    no: "01",
    title: "Office & Corporate",
    desc: "Daily and nightly janitorial programs for workplaces that never look off-duty.",
    tags: ["Janitorial", "Restrooms", "Break Rooms"],
    image: "https://images.unsplash.com/photo-1781637590564-01c65dbf2039?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwb2ZmaWNlJTIwY2xlYW5pbmclMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzg2NjY4NDI5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "02",
    title: "Glass & Partitions",
    desc: "Streak-free cleaning of interior glass, partitions, entrances and ground-floor storefronts.",
    tags: ["Interior Glass", "Partitions", "Entrances"],
    image: "https://images.unsplash.com/photo-1554232456-8727aae0cfa4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxlbXB0eSUyMG1vZGVybiUyMG9mZmljZSUyMGdsYXNzJTIwY2xlYW4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQ2NjA4OTV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "03",
    title: "Floor Care",
    desc: "Strip, seal, burnish and deep-extraction for hard floors and carpet.",
    tags: ["Buffing", "Extraction", "Sealing"],
    image: "https://images.unsplash.com/photo-1758193017781-e3aee6c3e359?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHBvbGlzaGVkJTIwY29tbWVyY2lhbCUyMGZsb29yJTIwbG9iYnl8ZW58MHx8fHwxNzg2NjM0MjI0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "04",
    title: "Post-Construction",
    desc: "Turn a build site into a move-in-ready space with fine-dust removal.",
    tags: ["Fine Dust", "Handover", "Deep Clean"],
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGVhbiUyMGNvcnBvcmF0ZSUyMGdsYXNzJTIwYnVpbGRpbmclMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODY2Njg0Mjl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "05",
    title: "Disinfection",
    desc: "Hospital-grade electrostatic disinfection with TGA-listed products for high-traffic touchpoints.",
    tags: ["Electrostatic", "TGA-listed", "Touchpoints"],
    image: "https://images.unsplash.com/photo-1522968941782-e27ac665baa3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjbGVhbiUyMGNvcnBvcmF0ZSUyMGdsYXNzJTIwYnVpbGRpbmclMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODY2Njg0Mjl8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title).concat("Something else");

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1779345169505-be7319f62b97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxqYW5pdG9yJTIwY2xlYW5pbmclMjBmbG9vciUyMG1vZGVybiUyMG9mZmljZXxlbnwwfHx8fDE3ODQxOTk3NDN8MA&ixlib=rb-4.1.0&q=85";

export const CLIENTS = [
  { name: "Dendy Cinemas", note: "Canberra" },
  { name: "PJ O'Reilly's", note: "Irish Bar" },
  { name: "Raku", note: "Restaurant" },
];

export const MANIFESTO = [
  {
    no: "01",
    head: "We treat cleaning like operations, not chores.",
    body: "Every account runs on a documented scope, checklists and QA audits. You get consistency you can measure — not a rotating cast of strangers.",
  },
  {
    no: "02",
    head: "Trained crews. Vetted, insured, accountable.",
    body: "Background-checked technicians, fully bonded and insured, supervised by a dedicated account manager who actually answers the phone.",
  },
  {
    no: "03",
    head: "Green by default, industrial when needed.",
    body: "Low-VOC chemistry and HEPA filtration as standard, with heavy-duty methods on tap for post-construction and industrial sites.",
  },
];

export const STATS = [
  { value: "2021", label: "serving Canberra since" },
  { value: "16", label: "cinema screens cleaned" },
  { value: "1,600+", label: "seats kept spotless" },
  { value: "6", label: "local service areas" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Insight took over cleaning across our three office sites and the difference was visible in a week. Reports every morning, zero surprises.",
    name: "Dana R.",
    role: "Facilities Director, Class-A Office REIT",
  },
  {
    quote:
      "The only vendor we've never had to chase. Their QA audits catch things before we ever notice them.",
    name: "Marcus L.",
    role: "Operations Manager, Logistics Group",
  },
];
